import { gql } from '@apollo/client';

// --- Feed Queries ---

export const FEED_BY_PLAYLIST_ID = gql`
  query FeedByPlaylistId($teamId: String!, $playlistId: String!) {
    feedByPlaylistId(teamId: $teamId, playlistId: $playlistId) {
      _id
      name
      description
      playlistId
      playlistOptions
      author
      duration
      orientation
      type
      thumbnail
      bucket
      status
      isPublic
      categoryIds
      tags
      featured
      rank
      accountId
      createdBy
      createdAt
      lastUpdatedDate
      lastUpdatedBy
      lastStatusUpdateDate
      lastStatusUpdateBy
      lastApprovedDate
      lastApprovedBy
    }
  }
`;

export const FEED_BY_ID = gql`
  query FeedById($id: String!) {
    feedById(id: $id) {
      _id
      name
      description
      playlistId
      playlistOptions
      author
      duration
      orientation
      type
      thumbnail
      bucket
      status
      isPublic
      categoryIds
      tags
      featured
      rank
      accountId
      createdBy
      createdAt
      lastUpdatedDate
      lastUpdatedBy
      lastStatusUpdateDate
      lastStatusUpdateBy
      lastApprovedDate
      lastApprovedBy
    }
  }
`;

export const MY_FEEDS = gql`
  query MyFeeds($first: Int, $after: String, $teamId: String) {
    myFeeds(first: $first, after: $after, teamId: $teamId) {
      page {
        edges {
          cursor
          node {
            _id
            name
            playlistId
            thumbnail
            status
            categoryIds
            tags
            createdAt
            lastUpdatedDate
            lastStatusUpdateDate
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
      pageData {
        total
      }
    }
  }
`;

export const PUBLISHED_FEEDS = gql`
  query PublishedFeeds($first: Int, $after: String, $teamId: String) {
    publishedFeeds(first: $first, after: $after, teamId: $teamId) {
      page {
        edges {
          cursor
          node {
            _id
            name
            playlistId
            thumbnail
            categoryIds
            tags
            rank
            featured
            isPublic
            lastStatusUpdateDate
            lastApprovedDate
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
      pageData {
        total
      }
    }
  }
`;

export const FEEDS_ADMIN_CATEGORIES = gql`
  query FeedsAdminCategories($first: Int, $after: String) {
    feedsAdminCategories(first: $first, after: $after) {
      page {
        edges {
          cursor
          node {
            _id
            name
            sortOrder
            sortOrderWidget
            createdAt
            lastUpdatedDate
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
      pageData {
        total
      }
    }
  }
`;

// --- Feed Mutations ---

export const CREATE_FEED = gql`
  mutation CreateFeed($teamId: String!, $input: CreateFeedInput!) {
    createFeed(teamId: $teamId, input: $input) {
      _id
      name
      playlistId
      status
      isPublic
      duration
      author
      playlistOptions
      categoryIds
      tags
      createdAt
    }
  }
`;

export const UPDATE_FEED = gql`
  mutation UpdateFeed($id: String!, $input: UpdateFeedInput!) {
    updateFeed(id: $id, input: $input) {
      _id
      name
      description
      playlistId
      playlistOptions
      author
      duration
      type
      thumbnail
      bucket
      status
      isPublic
      categoryIds
      tags
      featured
      rank
      lastUpdatedDate
    }
  }
`;

export const DELETE_FEED = gql`
  mutation DeleteFeed($id: String!) {
    deleteFeed(id: $id)
  }
`;

export const UPDATE_FEED_STATUS = gql`
  mutation UpdateFeedStatus($id: String!, $status: Int!) {
    updateFeedStatus(id: $id, status: $status) {
      _id
      status
      isPublic
      lastStatusUpdateDate
      lastStatusUpdateBy
    }
  }
`;

export const MAKE_FEED_PUBLIC = gql`
  mutation MakeFeedPublic($id: String!, $isPublic: Boolean!) {
    makeFeedPublic(id: $id, isPublic: $isPublic) {
      _id
      isPublic
      lastApprovedDate
      lastApprovedBy
    }
  }
`;

export const UPDATE_FEED_THUMBNAIL = gql`
  mutation UpdateFeedThumbnail($id: String!, $thumbnail: String!, $bucket: String) {
    updateFeedThumbnail(id: $id, thumbnail: $thumbnail, bucket: $bucket) {
      _id
      thumbnail
      bucket
    }
  }
`;

// --- Category Mutations ---

export const CREATE_FEED_CATEGORY = gql`
  mutation CreateFeedCategory($input: CreateFeedCategoryInput!) {
    createFeedCategory(input: $input) {
      _id
      name
      sortOrder
      sortOrderWidget
      createdAt
    }
  }
`;

export const UPDATE_FEED_CATEGORY = gql`
  mutation UpdateFeedCategory($id: String!, $input: UpdateFeedCategoryInput!) {
    updateFeedCategory(id: $id, input: $input) {
      _id
      name
      sortOrder
      sortOrderWidget
      lastUpdatedDate
    }
  }
`;

export const DELETE_FEED_CATEGORY = gql`
  mutation DeleteFeedCategory($id: String!) {
    deleteFeedCategory(id: $id)
  }
`;
